import { render, staticRenderFns } from "./ListAccessory.vue?vue&type=template&id=3a837288&scoped=true"
import script from "./ListAccessory.vue?vue&type=script&lang=js"
export * from "./ListAccessory.vue?vue&type=script&lang=js"
import style0 from "./ListAccessory.vue?vue&type=style&index=0&id=3a837288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a837288",
  null
  
)

export default component.exports